module.exports = __webpack_public_path__ + "static/media/record-nav-right-active.6bb74540.svg";